import React, { useEffect, useRef, useState } from 'react';
import { Group, Transformer } from 'react-konva';

const TransformableObject = ({ children, isSelected, onSelect, id, onTransformEnd, isLocked = false, rotation, offsetX, offsetY, groupX: rawGroupX = 0, groupY: rawGroupY = 0, showTransformer = false }) => {
  // Защита от NaN значений
  const groupX = isNaN(rawGroupX) ? 0 : rawGroupX;
  const groupY = isNaN(rawGroupY) ? 0 : rawGroupY;
  const groupRef = useRef();
  const transformerRef = useRef();
  const [isTransforming, setIsTransforming] = useState(false);

  useEffect(() => {
    if (isSelected && groupRef.current) {
      
      const node = groupRef.current;
      
      // Обновляем transformer, если он отрендерен
      if (showTransformer && transformerRef.current) {
        transformerRef.current.nodes([groupRef.current]);
        transformerRef.current.getLayer().batchDraw();
      }

      // Добавляем обработчики событий
      node.on('dragstart', () => {
        if (!isTransforming && transformerRef.current) {
          transformerRef.current.nodes([]);
        }
      });

      node.on('dragend', () => {
        if (isSelected && transformerRef.current && showTransformer) {
          transformerRef.current.nodes([node]);
          transformerRef.current.getLayer().batchDraw();
        }
      });

      node.on('transformstart', () => {
        setIsTransforming(true);
      });

      node.on('transformend', () => {
        setIsTransforming(false);
        if (onTransformEnd) {
          // Получаем текущие параметры трансформации из узла
          const rotation = node.rotation();
          const x = node.x();
          const y = node.y();
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          const offsetX = node.offsetX();
          const offsetY = node.offsetY();
          
          onTransformEnd({ rotation, x, y, scaleX, scaleY, offsetX, offsetY });
        }
      });

      return () => {
        node.off('dragstart');
        node.off('dragend');
        node.off('transformstart');
        node.off('transformend');
      };
    }
  }, [isSelected, id, isTransforming, onTransformEnd, showTransformer]);

  return (
    <>
      <Group
        ref={groupRef}
        onClick={(e) => {
          e.cancelBubble = true;
          onSelect();
        }}
        draggable={false}
        id={id}
        {...(rotation == null ? {} : { rotation })}
        {...(offsetX == null ? {} : { offsetX })}
        {...(offsetY == null ? {} : { offsetY })}
        x={groupX}
        y={groupY}
      >
        {React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, { isTransforming, isSelected })
            : child
        )}
      </Group>
      {isSelected && showTransformer && (
        <Transformer
          ref={transformerRef}
          resizeEnabled={!isLocked}
          rotateEnabled={!isLocked}
          borderEnabled={true}
          anchorSize={8}
          borderStroke={'#00ff00'}
          anchorStroke={'#00ff00'}
          anchorFill={'#ffffff'}
          anchorCornerRadius={2}
          enabledAnchors={[]}
          rotationSnaps={[0, 45, 90, 135, 180, 225, 270, 315]}
          rotationSnapTolerance={22.5}
          padding={5}
          ignoreStroke={true}
        />
      )}
    </>
  );
};

export default TransformableObject; 